import { useEffect, useState } from 'react'
import { useAppSelector } from '../../../hooks/redux'
import { RoutesPath } from '../../../constants/RoutesPath'
import { Strings } from '../../../constants/Strings'
import style from './NavBar.module.css'
import Theme from './Theme/Theme'
import Language from './Language/Language'
import NavBarItem from "./NavBarItem/NavBarItem"

const NavBar = () => {
    
    const language = useAppSelector<string>(state => state.language.language)

    const [isLoad, setIsLoad] = useState<boolean>(true)

    useEffect(() => {
        setTimeout(() => {
            setIsLoad(false)
        }, 100)
    }, [isLoad])

    return (
        <nav className={style.container}>
            {!isLoad && <>
                <Theme />
                <Language />
            </>}
            <NavBarItem
                to={RoutesPath.home}
                icon={"fas fa-home"}
                title={Strings[language ?? 'tm'].home}
                count={null}
            />
            <NavBarItem
                to={RoutesPath.termsOfUse}
                icon={"fas fa-handshake"}
                title={Strings[language ?? 'tm'].termsOfUse}
                count={null}
            />
            <NavBarItem
                to={RoutesPath.privacyPolicy}
                icon={"fas fa-shield-halved"}
                title={Strings[language ?? 'tm'].privacyPolicy}
                count={null}
            />
            <NavBarItem
                to={RoutesPath.aboutUs}
                icon={"fas fa-info-circle"}
                title={Strings[language ?? 'tm'].aboutUs}
                count={null}
            />
        </nav>
    )
}

export default NavBar
